module.exports = __webpack_public_path__ + "img/whiterpaper-hover.db15d62d.svg";